import React from 'react'

export function TagBox({children}: {children: React.ReactNode}) {
  return (
    <div className="sa-bg-yellow sa-text-blue tw-inline-block tw-rounded-full tw-px-2 tw-text-[12px] tw-mx-4">{children}</div>
  )
}